import * as React from "react";
import StepOne from "./StepOne";
import { connect } from "react-redux";
import StepTwo from "./StepTwo";
import StepTwoOld from "./StepTwoOld";
import StepTwoFixedAmount from "./StepTwoFixedAmount";
import StepThree from "./StepThree";
import StepFour from "./Rki";
import StepSix from "./Marital";
import StepSeven from "./Children";
import StepFive from "./LoanReason";
import StepEight from "./CoApplicant";
import StepCoappliant from "./StepCoappliant";
import StepNine from "./Dwelling";
import StepTen from "./Cars";
import StepPayment from "./StepPayment";
import StepConsent from "./StepConsent";
import StepCallback from "./StepCallback";

import { RootState } from "../../store";
import { Step } from "../../store/application/applicationState";
import ApplicationContainer from "../applicationContainer";
import ReactDOM from "react-dom";
import { number } from "prop-types";


type Props = ReturnType<typeof mapStateToProps>;

class LoanForm extends React.Component<Props, {}> {
  constructor(props: any) {
    super(props);
  }

  isInViewport(elem: HTMLElement) {
    var bounding = elem.getBoundingClientRect();
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  componentDidUpdate() {
    try {
        const element = ReactDOM.findDOMNode(this);
        const element2 = document.getElementById("applynow");
        if (element2 instanceof HTMLElement) {
           // if (!this.isInViewport(element2)) {
            element2.scrollIntoView();
       // }
      }
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    return (
      <ApplicationContainer>
        {StepRenderer(this.props.step)}
      </ApplicationContainer>
    );
  }
}

const StepRenderer = (step: Step) => {
       
  switch (step) {
    case Step.Main:
      return <StepOne />;
    case Step.Amount:
          return <StepTwo />;
      case Step.AmountAlt:
          return <StepTwoOld />;
      case Step.AmountLanding:
          return <StepTwoFixedAmount />;
    case Step.Contact:
      return <StepThree />;
    case Step.RKI:
      return <StepFour />;
      case Step.LoanReason:
          return <StepFive />;
      case Step.Marital:
          return <StepSix />;
      case Step.Children:
          return <StepSeven />;
    case Step.Coappliant:
          return <StepEight />;
      case Step.CoappliantContact:
          return <StepCoappliant />;
      case Step.Dwelling:
          return <StepNine />;
    case Step.Cars:
          return <StepTen />;
    case Step.Payment:
      return <StepPayment />;
    case Step.Consent:
      return <StepConsent />;
    case Step.Callback:
          return <StepCallback />;
    default:
      return null;
    }

    
};

const mapStateToProps = (state: RootState) => ({
  step: state.applicationState.currentStep
});

export default connect(mapStateToProps)(LoanForm);
